// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.math.deg-per-rad.js
// module id = 1003
// module chunks = 0